import React from 'react';
import classNames from 'classnames/bind';
import styles from './Wrapper.module.scss';
import { Box } from '@mui/material';

const cx = classNames.bind(styles);

interface WrapperProps {
    children: React.ReactNode;
}

export default function Wrapper({children}: WrapperProps) {
    return <Box className={cx('wrapper')}>{children}</Box>;
};